(function() {
  function defineCDEWrapper(wrapperName, tagName, customContent) {
    if (!customElements.get(wrapperName)) {
      if (customContent) {
        new Function(customContent)();
      }

      customElements.define(
        wrapperName,
        class extends HTMLElement {
          constructor() {
            super();
            const handler = {
              set: (target, name, value) => {
                this._innerTag[name] = value;
                return true;
              },
              get(target, name, receiver) {
                return Reflect.get(target, name, receiver);
              }
            };
            this._innerTag = document.createElement(tagName);
            Object.setPrototypeOf(
              this,
              new Proxy(Object.create(HTMLElement.prototype), handler)
            );
          }

          connectedCallback() {
            const blockList = ["elm_event_node_ref", "_innerTag"];
            const props = Object.keys(this).filter(k => {
              return blockList.indexOf(k) === -1;
            });

            props.forEach(prop => {
              this._innerTag[prop] = this[prop];
            });
            this.appendChild(this._innerTag);
          }

          disconnectedCallback() {
            this.removeChild(this._innerTag);
          }
        }
      );
    }
  }

  window.defineCDEWrapper = defineCDEWrapper;
})();
